export default "__VITE_ASSET__30ea92bc__"